var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function insertIntoStepInformation(_a) {
    var stepKey = _a.stepKey, data = _a.data, _b = _a.wrapAround, wrapAround = _b === void 0 ? false : _b;
    if (!stepKey) {
        console.warn("insertIntoNextStepInformation: se requiere stepKey");
        return null;
    }
    var steps = [];
    try {
        var raw = localStorage.getItem("steps") || "[]";
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed))
            steps = parsed;
    }
    catch (e) {
        console.error("LS 'steps' inválido:", e);
        return null;
    }
    if (steps.length === 0)
        return null;
    var idx = steps.findIndex(function (s) { return s.id === stepKey || (s.pathUrl || "") === stepKey; });
    if (idx === -1)
        return null;
    var nextIdx = idx + 1;
    if (nextIdx >= steps.length) {
        if (!wrapAround)
            return null;
        nextIdx = 0;
    }
    var target = __assign({}, steps[nextIdx]);
    var currentInfo = __assign({}, (target.stepInformation || {}));
    var nextInfo = __assign({}, currentInfo);
    Object.entries(data).forEach(function (_a) {
        var k = _a[0], v = _a[1];
        if (v !== undefined && nextInfo[k] === undefined) {
            nextInfo[k] = v;
        }
    });
    target.stepInformation = nextInfo;
    steps[nextIdx] = target;
    localStorage.setItem("steps", JSON.stringify(steps));
    return target;
}
